import * as React from 'react';
import { Tabs } from 'antd';
import { HistoryOutlined, SendOutlined } from '@ant-design/icons';

import { Page } from 'components/page/page';
import { Card } from 'components/card/card';
import { SendForm } from './send-form';
import { History } from './history';
import './send-bulk-sms.scss';

type TabKey = 'send' | 'history';

export const SendBulkSms: React.FC = () => {
    const [activeTab, setActiveTab] = React.useState<TabKey>('send');
    const [historyBatchId, setHistoryBatchId] = React.useState<string>();

    return (
        <Page className="pmx-send-bulk-sms" title="پیامک گروهی">
            <Card>
                <Tabs
                    activeKey={activeTab}
                    onChange={(key) => {
                        setActiveTab(key as TabKey);
                        if (key === 'send') setHistoryBatchId(undefined);
                    }}
                    items={[
                        {
                            key: 'send',
                            label: (
                                <span>
                                    <SendOutlined /> ارسال جدید
                                </span>
                            ),
                            // فرم باید با رفتن به تب سوابق سر جایش بماند (ارسال در حال انجام قطع نشود).
                            forceRender: true,
                            children: (
                                <SendForm
                                    onShowHistory={(batchId) => {
                                        setHistoryBatchId(batchId);
                                        setActiveTab('history');
                                    }}
                                />
                            ),
                        },
                        {
                            key: 'history',
                            label: (
                                <span>
                                    <HistoryOutlined /> سوابق ارسال
                                </span>
                            ),
                            // با هر بار باز شدن تب، لیست تازه می‌شود.
                            children: activeTab === 'history' && <History batchId={historyBatchId} />,
                        },
                    ]}
                />
            </Card>
        </Page>
    );
};
